import { useState, useEffect, useRef } from 'react';
import { ActionButton } from '../../common/Buttons/Buttons';
import { Header } from '../../common/Header/Header.jsx';
import { Input } from '../../common/Forms/Input/Input';
import * as schemas from '../../../assets/schemas/schemas';
import { yupResolver } from '@hookform/resolvers/yup';
import { notify } from '../../../assets/helpers/toast';
import { salesRoles, transcriptRoles } from '../../../assets/helpers/roles.js';
import { useHistory } from 'react-router-dom';
import { filterParams } from '../../../assets/helpers/funciones';
import { sellerComissionService } from '../../../services/sellerComissionService.js';
import { rolesService } from '../../../services/rolesService.js';
import { monthsComissionsOptions } from '../../../assets/helpers/options.js';
import { LoadSpinner } from '../../common/LoadSpinner/LoadSpinner.jsx';
import { GoalsTables } from '../../common/Tables/Tables.jsx';
import { goalsTableHeader } from '../../../assets/helpers/tables.js';
import { usersService } from '../../../services/usersService.js';
import { CreateGoalModal, EditGoalModal } from '../../common/Modals/Modals.jsx';
import { useForm } from 'react-hook-form';

export const Goals = () => {
  const history = useHistory();
  const {
    register,
    formState: { errors },
    watch,
  } = useForm({
    resolver: yupResolver(schemas.comissionsConfigParams()),
  });

  const [yearOptions, setYearOptions] = useState([]);
  const [rolesOptions, setRolesOptions] = useState([]);
  const [hunterOptions, setHunterOptions] = useState([]);
  const [farmerOptions, setFarmerOptions] = useState([]);
  const [counterOptions, setCounterOptions] = useState([]);
  const [keyAccountsOptions, setKeyAccountsOptions] = useState([]);
  const [userOptions, setUserOptions] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [showCreateGoalModal, setCreateShowGoalModal] = useState({
    role: '',
    isOpen: false,
  });
  const [showEditGoalModal, setEditShowGoalModal] = useState({
    role: '',
    isOpen: false,
  });

  const [membershipsDatatable, setMembershipsDatatable] = useState({
    offset: 0,
    data: [],
    count: 0,
    month: '',
    year: '',
    isLoading: false,
    searchParam: '',
  });

  const {
    register: register2,
    handleSubmit: handleSubmit2,
    errors: errors2,
    reset: reset2,
    setValue: setValue2,
    watch: watch2,
  } = useForm({
    resolver: yupResolver(schemas.createComissionConfig()),
  });

  const {
    register: register3,
    handleSubmit: handleSubmit3,
    errors: errors3,
    reset: reset3,
    setValue: setValue3,
    watch: watch3,
  } = useForm({
    resolver: yupResolver(schemas.createComissionConfig()),
  });

  const onSubmit = handleSubmit2(async (data) => {
    let payload = {
      role: data.group,
      month: Number(data.month),
      year: Number(data.year),
      sellerGoal: data.sellerGoal,
      groupGoal: data.groupGoal,
      sellersConfig: [],
    };

    for (let i = 0; i < userOptions.length; i++) {
      payload.sellersConfig.push({
        seller: data?.[`goalUser${i}`],
        goal: Number(data?.[`goalUserAmount${i}`]),
        excluded: data?.[`userAppliesToGoal${i}`],
      });
    }
    sellerComissionService
      .createComissionConfig(payload)
      .then((response) => {
        if (response.status === 200) {
          notify(`Meta configurada con éxito.`, 'success');
          reset2();
          getComissionsConfig();
          setCreateShowGoalModal({ ...showCreateGoalModal, isOpen: false });
        } else {
          notify(`${response.message}`, 'error');
        }
      })
      .catch((error) => {
        notify(`Error al configurar la meta.`, 'error');
      });
  });

  const handleUserOptions = () => {
    rolesOptions.forEach((option) => {
      if (option._id === watch2('group')) {
        if (option.name === transcriptRoles(salesRoles.SALES_HUNTER)) {
          setUserOptions(hunterOptions);
        } else if (option.name === transcriptRoles(salesRoles.SALES_FARMER)) {
          setUserOptions(farmerOptions);
        } else if (option.name === transcriptRoles(salesRoles.SALES_COUNTER)) {
          const filteredCounter = counterOptions.filter(
            (user) => user.type === 'Interno'
          );
          setUserOptions(filteredCounter);
        } else if (option.name === transcriptRoles(salesRoles.SALES_KEY_ACCOUNTS)) {
          setUserOptions(keyAccountsOptions);
        } else {
          setUserOptions([]);
        }
      }
    });
    userOptions.forEach((user, index) => {
      setValue2(`goalUser${index}`, user._id);
      setValue2(`goalUserAmount${index}`, watch2('sellerGoal'));
      setValue2(`userAppliesToGoal${index}`, false);
    });
  };

  useEffect(() => {
    handleUserOptions();
  }, [watch2('group'), watch2('sellerGoal')]);

  const preloadOptions = async (currentYear) => {
    let years = [];

    for (let i = currentYear + 1; i > 2000; i--) {
      years.push({
        name: i.toString(),
        _id: i.toString(),
      });
    }
    setYearOptions(years);
  };

  const getRoles = () => {
    rolesService
      .getRoles('Ventas')
      .then((response) => {
        if ([200, 201].includes(response?.status)) {
          let data = [...response?.data];
          for (let i = 0; i < data.length; i++) {
            data[i].name = transcriptRoles(data[i]?.name);
          }
          data = data.filter((role) =>
            ['Farmer', 'Hunter', 'Counter']?.includes(role.name)
          );
          setRolesOptions(data);
        } else {
          notify(`${response.message}` || 'error', 'error');
        }
      })
      .catch(() => {});
  };

  const getSalesUsers = () => {
    let params = {
      limit: 1000,
      offset: 0,
      module: 'Ventas',
      status: 'Activo',
    };

    usersService
      .getSalesUsers(params)
      .then((response) => {
        if (response.status === 200) {
          const hunters = response.data.users.filter(
            (user) => user.role === salesRoles.SALES_HUNTER
          );
          const farmers = response.data.users.filter(
            (user) => user.role === salesRoles.SALES_FARMER
          );
          const counters = response.data.users.filter(
            (user) => user.role === salesRoles.SALES_COUNTER
          );
          const keyAccounts = response.data.users.filter(
            (user) => user.role === salesRoles.SALES_KEY_ACCOUNTS
          );
          setHunterOptions(hunters);
          setFarmerOptions(farmers);
          setCounterOptions(counters);
          setKeyAccountsOptions(keyAccounts);
        } else {
          notify(`${response.message}` || 'error', 'error');
        }
      })
      .catch((error) => {
        console.error(error);
      });
    return true;
  };

  const getComissionsConfig = () => {
    setIsLoading(false);

    let params = {};

    if (watch('role')) {
      params.role = watch('role');
    }
    if (watch('month')) {
      params.month = watch('month');
    }

    if (watch('year')) {
      params.year = watch('year');
    }

    if (!isLoading) {
      setIsLoading(true);
      sellerComissionService
        .getComissionConfig(filterParams(params))
        .then((response) => {
          const groupedByRole = {};
          response?.data?.sellerComissionConfig?.forEach((item) => {
            if (!groupedByRole[item.role]) {
              groupedByRole[item.role] = [];
            }
            groupedByRole[item.role].push(item);
          });
          const arrayBySeller = Object.keys(groupedByRole).map((role) => {
            return {
              role,
              roleName: groupedByRole[role]?.[0]?.roleName,
              items: groupedByRole[role],
            };
          });
          if (response.status === 200) {
            setMembershipsDatatable((prevState) => {
              return {
                ...prevState,
                count: response?.data?.total,
                data: arrayBySeller,
              };
            });
            setIsLoading(false);
          } else {
            notify(`${response.message}` || 'error', 'error');
            setIsLoading(false);
          }
        })
        .catch(() => {
          setIsLoading(false);
        });
    }
  };

  const editAction = (data) => {
    let users = [];
    setValue3('id', data._id);
    setValue3('group', data.role);
    setValue3('month', data.month);
    setValue3('year', data.year);
    setValue3('sellerGoal', data.sellerGoal);
    setValue3('groupGoal', data.groupGoal);
    data.sellersConfig.forEach((seller, index) => {
      setValue3(`goalUser${index}`, seller.seller);
      setValue3(`goalUserAmount${index}`, seller.goal);
      setValue3(`userAppliesToGoal${index}`, seller.excluded);
      users.push({
        _id: seller.seller,
        firstName: seller.sellerName ? seller.sellerName : '',
        lastName: seller.sellerLastName ? seller.sellerLastName : '',
      });
    });

    setEditShowGoalModal({
      isOpen: true,
      users: users,
    });
  };

  const onSubmitEdit = handleSubmit3(async (data) => {
    let payload = {
      role: data.group,
      month: Number(data.month),
      year: Number(data.year),
      sellerGoal: data.sellerGoal,
      groupGoal: data.groupGoal,
      sellersConfig: [],
    };

    for (let i = 0; i < showEditGoalModal.users.length; i++) {
      payload.sellersConfig.push({
        seller: data?.[`goalUser${i}`],
        goal: Number(data?.[`goalUserAmount${i}`]),
        excluded: data?.[`userAppliesToGoal${i}`],
      });
    }
    sellerComissionService
      .updateComissionConfig(data.id, payload)
      .then((response) => {
        if (response.status === 200) {
          notify(`Meta Actualizada con éxito.`, 'success');
          reset3();
          getComissionsConfig();
          setEditShowGoalModal({
            ...showEditGoalModal,
            isOpen: false,
            users: [],
          });
        } else {
          notify(`${response.message}`, 'error');
        }
      })
      .catch((error) => {
        notify(`Error al configurar la meta.`, 'error');
      });
  });

  const createNewGoal = () => {
    setCreateShowGoalModal({
      isOpen: true,
    });
  };

  useEffect(() => {
    getRoles();
    preloadOptions(new Date()?.getFullYear());
    getSalesUsers();
  }, []);

  useEffect(() => {
    getRoles();
    preloadOptions(new Date()?.getFullYear());
    getSalesUsers();
  }, []);

  useEffect(() => {
    getComissionsConfig();
  }, [watch('role'), watch('month'), watch('year')]);

  return (
    <>
      <Header />
      <LoadSpinner show={isLoading} />

      <CreateGoalModal
        show={showCreateGoalModal.isOpen}
        handleClose={(close) =>
          setCreateShowGoalModal({ ...showCreateGoalModal, isOpen: close })
        }
        handleRole={(role) =>
          setCreateShowGoalModal({
            ...showCreateGoalModal,
            role: role,
          })
        }
        options={{
          userOptions: userOptions,
          groupOptions: rolesOptions,
          yearOptions: yearOptions,
          monthOptions: monthsComissionsOptions,
        }}
        register={register2}
        onSubmit={onSubmit}
        errors={errors2}
        watch={watch2}
        role={showCreateGoalModal.role}
        getComissionsConfig={getComissionsConfig}
        setValue={setValue2}
      />

      <EditGoalModal
        show={showEditGoalModal.isOpen}
        handleClose={(close) =>
          setEditShowGoalModal({ ...showEditGoalModal, isOpen: close })
        }
        handleRole={(role) =>
          setEditShowGoalModal({
            ...showCreateGoalModal,
            role: role,
          })
        }
        options={{
          userOptions: showEditGoalModal.users,
          groupOptions: rolesOptions,
          yearOptions: yearOptions,
          monthOptions: monthsComissionsOptions,
        }}
        register={register3}
        onSubmit={onSubmitEdit}
        errors={errors3}
        watch={watch3}
        role={showEditGoalModal.role}
        getComissionsConfig={getComissionsConfig}
        setValue={setValue3}
      />

      <div
        className="buttons-container"
        style={{ margin: '1%', padding: '1%' }}
      >
        <h1 className="title-component">Metas B2C</h1>
        <div style={{ display: 'flex' }}>
          <ActionButton
            label={'Comisiones'}
            action={() => history.push(`/admin/consultant-commissions`)}
          />
          {membershipsDatatable?.data?.length === 0 && (
            <ActionButton label={'Nueva Meta'} action={() => createNewGoal()} />
          )}
        </div>
        <div
          className="exportables-buttons-container"
          style={{
            display: 'flex',
            justifyContent: 'flex-end',
            alignItems: 'center',
            width: '100%',
            gap: '10px',
          }}
        >
          <Input
            bootstrap={'col-12 col-md-1'}
            label={'Mes'}
            type={'select'}
            name={'month'}
            options={monthsComissionsOptions}
            register={register}
            placeholder={''}
            errors={errors?.month?.message}
          />
          <Input
            bootstrap={'col-12 col-md-1'}
            label={'Año'}
            type={'select'}
            name={'year'}
            options={yearOptions}
            register={register}
            placeholder={''}
            errors={errors?.month?.message}
          />{' '}
          <Input
            bootstrap={'col-12 col-md-1'}
            label={'Tipo de Asesor'}
            type={'select'}
            name={'role'}
            options={rolesOptions}
            register={register}
            placeholder={''}
            errors={errors?.role?.message}
          />
        </div>
        {membershipsDatatable?.data.map((item, index) => (
          <GoalsTables
            key={index}
            header={goalsTableHeader}
            data={membershipsDatatable?.data[index]}
            createAction={() => {
              setCreateShowGoalModal({
                isOpen: true,
              });
              setValue2('group', membershipsDatatable?.data[index]?.role);
              setValue2('sellerGoal', 0);
              handleUserOptions();
            }}
            editAction={editAction}
          />
        ))}

        {membershipsDatatable?.data?.length === 0 && (
          <div
            style={{
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              justifyContent: 'center',
              height: '100%',
              textAlign: 'center',
              width: '100%',
            }}
          >
            <h4 style={{ textAlign: 'center', marginTop: '24px' }}>
              No hay data disponible para el periodo seleccionado
            </h4>
          </div>
        )}
      </div>
    </>
  );
};
